import { usePathname as useNextPathname } from "@/i18n/routing";
import { useParams } from "next/navigation";

export const usePathname = () => {
  const pathname = useNextPathname();
  const params = useParams();
  const store = params.store as string;

  if (!store || !pathname.startsWith(`/${store}`)) {
    return pathname;
  }

  return pathname.replace(`/${store}`, "") || "/";
};
